module.exports = __webpack_public_path__ + "img/pizzalogo.1284650b.png";